import './S_Feedback.scss';
import classNames from 'classnames';
import { ReactElement, ReactNode } from 'react';
interface IProps {
  className?: string;
  children?: ReactNode;
}

export const S_Feedback = ({ children, className }: IProps): ReactElement => <div className={classNames('feedback', className)}>{children}</div>;
